<template>
    <b-modal ref="modal" centered no-close-on-backdrop no-close-on-esc hide-header hide-footer>
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('JOBFORM')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
          <div role="group" class="b-form-group form-group" v-if="formData != null">
              <div class="form-row" v-if="(globals && globals.acl && globals.acl.Job && globals.acl.Job.insertAction) ? true : false">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('JOBNUMBER')">
                    <inputvalidation :formerror="formError" name="jobNumber">
                      <b-form-input type="number" v-model="formData.jobNumber"></b-form-input>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('BUILDING')">
                    <inputvalidation :formerror="formError" name="buildingDetailIds">
                        <lbselect
                          :empty="true"
                          :multiselect="(formData.jobId != null) ? false : true"
                          :list="buildingDetail.root"
                          :total-count="buildingDetail.totalCount"
                          :pagination="buildingDetailPagination"
                          v-on:reload="getBuildingDetail()"
                          v-model="formData.buildingDetailIds"
                          value-field="buildingDetailId"
                          :display-func="(item) => getBuildingDetailName(item)">
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row" v-if="(globals && globals.groupId == 6) ? true : false">
                <div class="col-sm-6">
                  <b-form-fieldset v-bind:label="$t('SERVICEPROVIDERORWORKER')">
                    <inputvalidation :formerror="formError" name="overwrite">
                      <b-form-checkbox v-model="showCompanyWorker" :value="true" :unchecked-value="false">{{$t('SERVICEPROVIDERORWORKER')}}</b-form-checkbox>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row" v-if="globals.acl.UserSubCompanies && globals.acl.UserSubCompanies.insertAction && showCompanyWorker == false">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('USERSUBCOMPANIES')">
                    <inputvalidation :formerror="formError" name="subCompanyId">
                        <lbselect
                          :empty="true"
                          :list="subCompany.root"
                          :total-count="subCompany.totalCount"
                          :pagination="subCompanyPagination"
                          v-on:reload="getSubCompany()"
                          v-model="formData.subCompanyId"
                          value-field="subCompanyId"
                          display-field="subCompanyName">
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row" v-if="(globals && globals.groupId == 6 && showCompanyWorker == true) ? true : false">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('COMPANYWORKER')">
                    <inputvalidation :formerror="formError" name="companyWorkerId">
                        <lbselect
                          :empty="true"
                          :list="companyWorker.root"
                          :total-count="companyWorker.totalCount"
                          :pagination="companyWorkerPagination"
                          v-on:reload="getUsers()"
                          v-model="formData.companyWorkerId"
                          value-field="userId"
                          :display-func="(item) => getCompaynWorkerName(item)">>
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row" v-if="(globals && globals.acl && globals.acl.Job && globals.acl.Job.insertAction) ? true : false">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('FLOW')">
                    <inputvalidation :formerror="formError" name="flowId">
                        <lbselect
                          :empty="true"
                          :list="flow.root"
                          :total-count="flow.totalCount"
                          :pagination="flowPagination"
                          v-on:reload="getFlow()"
                          v-model="formData.flowPrimaryId"
                          value-field="flowId"
                          display-field="description">
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row" v-if="(globals && globals.acl && globals.acl.Job && globals.acl.Job.insertAction) ? true : false">
                <div class="col-sm-12">
                  <b-form-fieldset v-bind:label="$t('FLOWSEC')">
                    <inputvalidation :formerror="formError" name="flowId">
                        <lbselect
                          :empty="true"
                          :list="flowSec.root"
                          :total-count="flowSec.totalCount"
                          :pagination="flowSecPagination"
                          v-on:reload="getFlowSec()"
                          v-model="formData.flowSecId"
                          value-field="flowId"
                          display-field="description">
                        </lbselect>
                    </inputvalidation>
                  </b-form-fieldset>
                </div>
              </div>
              <div class="form-row" v-if="(globals && globals.acl && globals.acl.Job && globals.acl.Job.insertAction) ? true : false">
                <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('SHOWPERIOD')">
                        <inputvalidation :formerror="formError" name="overwrite">
                            <b-form-checkbox v-model="showPeriod" :value="1" :unchecked-value="0">{{$t('SHOWPERIOD')}}</b-form-checkbox>
                        </inputvalidation>
                    </b-form-fieldset>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-12" v-if="!showPeriod">
                    <b-form-fieldset v-bind:label="$t('DATE')">
                        <inputvalidation :formerror="formError" name="jobDate">
                            <datetimepicker
                                type="datetime"
                                v-model="formData.jobDate"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="DD.MM.YYYY. HH:mm"
                                :showSeconds="false"
                                :isUTC="true"
                                :simple="true"
                                :translate-method="trans">
                            </datetimepicker>
                        </inputvalidation>
                    </b-form-fieldset>
                </div>
            </div>
            <div class="form-row" v-if="showPeriod && (globals && globals.acl && globals.acl.Job && globals.acl.Job.insertAction)">
                <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('STARTDATE')">
                        <inputvalidation :formerror="formError" name="jobStartDate">
                            <datetimepicker type="date"
                                v-model="formData.jobStartDate"
                                format="YYYY-MM-DD"
                                display-format="DD.MM.YYYY."
                                :simple="true"
                                :translate-method="trans">
                            </datetimepicker>
                        </inputvalidation>
                    </b-form-fieldset>
                </div>
                <div class="col-sm-6">
                    <b-form-fieldset v-bind:label="$t('ENDDATE')">
                        <inputvalidation :formerror="formError" name="jobEndDate">
                            <datetimepicker type="date"
                                v-model="formData.jobEndDate"
                                format="YYYY-MM-DD"
                                display-format="DD.MM.YYYY."
                                :simple="true"
                                :translate-method="trans">
                            </datetimepicker>
                        </inputvalidation>
                    </b-form-fieldset>
                </div>
            </div>
            <div class="form-row" v-if="(globals && globals.acl && globals.acl.Job && globals.acl.Job.insertAction) ? true : false">
                <div class="col-sm-12">
                <b-form-fieldset v-bind:label="$t('COMMENT')">
                    <inputvalidation :formerror="formError" name="comment">
                        <b-form-textarea type="text" v-model="formData.comment"></b-form-textarea>
                    </inputvalidation>
                </b-form-fieldset>
                </div>
            </div>
          </div>

          <div class="text-center mt-lg">
              <b-btn class="mr-2 btn-bis btn-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
              <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
          </div>

          </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';
import Api from '@/api/job/Job.js';
import SubcompanyApi from '@/api/admin/UserSubCompanies'
import FlowApi from '@/api/flow/FlowOperatorObligations.js';
import FlowSecApi from '@/api/flow/FlowTrafficSafetyManagment.js';
import BuildingDetailApi from '@/api/building_detail/BuildingDetail.js';
import UserApi from '@/api/admin/Users'
import localTranslate from '../../helpers/local_trans';


export default
{
    name: 'JobForm',
    props: ['value'],
    data()
    {
        const me = this;

        return {
            buildingDetail: {},
            companyWorker: {},
            subCompany: {},
            flow: {},
            flowSec: {},
            formError: {},
            formData: null,
            showCompanyWorker: false,
            showPeriod: 0,
            flowId: null,
            flowPrimaryId: null,
            flowSecId: null,
            triggerWatch: true,
            triggerWatchSec: true,
            initLoad: true,
            dateType:
            [
                {
                    value: 'days',
                    text: me.$i18n.t('DAYS')
                },
                {
                    value: 'weeks',
                    text: me.$i18n.t('WEEKS')
                },
                {
                    value: 'months',
                    text: me.$i18n.t('MONTHS')
                },
                {
                    value: 'years',
                    text: me.$i18n.t('YEARS')
                }
            ],
            buildingDetailPagination: {
                query: '',
                currentPage: 1,
                initialId: [],
                limit: 25,
                searchTimeout: false,
            },
            companyWorkerPagination: {
                query: '',
                currentPage: 1,
                initialId: [],
                limit: 25,
                searchTimeout: false,
            },
            flowPagination: {
                query: '',
                currentPage: 1,
                initialId: [],
                limit: 25,
                searchTimeout: false,
            },
            flowSecPagination: {
                query: '',
                currentPage: 1,
                initialId: [],
                limit: 25,
                searchTimeout: false,
            },
            subCompanyPagination: {
                query: '',
                currentPage: 1,
                initialId: [],
                limit: 25,
                searchTimeout: false,
            },
        };
    },
    methods:
    {
        trans(key)
        {
            const me = this;
            return localTranslate(me.globals.langId, key);
        },
        getBuildingDetailName(item)
        {
            let str = `${item.clientName} ${item.address}`;
            return str;
        },
        getCompaynWorkerName(item)
        {
            let str = `${item.name} ${item.surname}`;
            return str;
        },
        getCompanyWorkerSubCompanyId(companyWorkerId)
        {
            const me = this;

            const worker = me.companyWorker.root.find(
                (item) => item.userId == companyWorkerId
            );

            return worker ? worker.subCompanyId : null;
        },
        async submitData(item)
        {
            const me = this;
            try
            {
                if (typeof item.jobId !== 'undefined')
                {
                    item.id = item.jobId;
                    delete (item.jobId);
                }

                if (item.flowPrimaryId != null)
                {
                    item.flowId = item.flowPrimaryId;
                }
                else
                {
                    item.flowId = item.flowSecId;
                }

                if (item.companyWorkerId)
                {
                    item.subCompanyId = me.getCompanyWorkerSubCompanyId(item.companyWorkerId);
                }

                const data = await Api.save(item);
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
                else
                {
                    me.close();
                }
            }
            catch (e)
            {
              console.log(e);
                me.$notify.notice(e);
            }
        },
        async getSubCompany()
        {
            const me = this;
            try
            {
                const data = await SubcompanyApi.selectRow(me.getSubCompanyParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.subCompany = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async getBuildingDetail()
        {
            const me = this;
            try
            {
                const data = await BuildingDetailApi.selectRow(me.getBuildingDetailParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.buildingDetail = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async getUsers()
        {
            const me = this;
            try
            {
                const data = await UserApi.selectByConnectedCompanyId(me.getCompanyWorkerParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }

                for(var i=0;i<data.root.length;i++)
                {
                    data.root[i].trhidden = false;
                }

                me.companyWorker = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async getFlow()
        {
            const me = this;
            try
            {
                const data = await FlowApi.selectRow(me.getFlowParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.flow = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        async getFlowSec()
        {
            const me = this;
            try
            {
                const data = await FlowSecApi.selectRow(me.getFlowSecParams);
                if (data.error && data.error === true)
                {
                    throw (data);
                }
                me.flowSec = data;
            }
            catch (error)
            {
                me.$notify.notice(error);
            }
        },
        close()
        {
            const me = this;
            me.formData = null;
            me.formError = {};
            me.showPeriod = 0;
            me.buildingDetail = {};
            me.companyWorker = {};
            me.subCompany = {};
            me.flow = {};
            me.flowSec = {};
            me.formError = {};
            me.$emit('close');
        },
    },
    watch:
    {
        'formData.flowPrimaryId': function(val)
        {
            const me = this;
            if (me.triggerWatch)
            {
                if (me.formData.flowSecId != null)
                {
                    me.triggerWatchSec = false;
                    me.formData.flowSecId = null;
                }
            }
            setTimeout(() =>
            {
                me.triggerWatch = true;
            }, 500);
        },
        'formData.flowSecId': function(val)
        {
            const me = this;
            if (me.triggerWatchSec)
            {
                if (me.formData.flowPrimaryId != null)
                {
                    me.triggerWatch = false;
                    me.formData.flowPrimaryId = null;
                }
            }
            setTimeout(() =>
            {
                me.triggerWatchSec = true;
            }, 500);
        },
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                await me.getSubCompany();
                await me.getBuildingDetail();
                await me.getUsers();
                await me.getFlow();
                await me.getFlowSec();

                if ((val.jobStartDate != null && val.jobStartDate !== '')
                    || (val.jobEndDate != null && val.jobEndDate !== ''))
                {
                    me.showPeriod = 1;
                }

                if (val.companyWorkerId)
                {
                    me.showCompanyWorker = true;
                }
                else
                {
                    me.showCompanyWorker = false;
                }

                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
        showPeriod(val)
        {
            const me = this;
            if (me.formData != null)
            {
                if (val === 1)
                {
                    me.formData.jobDate = null;
                }
                else
                {
                    me.formData.jobStartDate = null;
                    me.formData.jobEndDate = null;
                }
            }
        }
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
        getBuildingDetailParams()
      {
          const me = this;
          const data = { ...me.buildingDetailPagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getCompanyWorkerParams()
      {
          const me = this;
          const data = { ...me.companyWorkerPagination };
          data.start = (data.currentPage - 1) * data.limit;
          data.getWorkers = true;
          return data;
      },
      getFlowParams()
      {
          const me = this;
          const data = { ...me.flowPagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getFlowSecParams()
      {
          const me = this;
          const data = { ...me.flowSecPagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getSubCompanyParams()
      {
          const me = this;
          const data = { ...me.subCompanyPagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
    },
};
</script>
